import { SetStateAction, Dispatch } from 'react'
import { Button, IconButton, ToggleButton, ToggleButtonGroup } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import { useHideUserWelcome } from 'src/hooks'

import { EDashboardTab, ETranslationNs, IAccountByIdRespDto, IProfileUserResponse } from 'src/types'
import { useStyles } from './styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  tab: EDashboardTab
  me: IProfileUserResponse | null | void
  handleTab: (tab: EDashboardTab) => void
  setTab?: Dispatch<SetStateAction<EDashboardTab>>
  account: IAccountByIdRespDto
}

export const TabToggle = ({ tab, me, handleTab, account, setTab }: IProps) => {
  const classes = useStyles()
  const { mutateAsync: hide, isLoading, isSuccess } = useHideUserWelcome()

  if (me === null) {
    setTab && setTab(EDashboardTab.Welcome)
  }

  if ((!me?.show_welcome || !account.show_welcome) && tab === EDashboardTab.Dashboard) {
    return null
  }

  const handleHide = async () => {
    setTab && setTab(EDashboardTab.Dashboard)
    await hide()
  }

  const handleChange = (e: any, value: EDashboardTab) => {
    if (value === tab) return
    handleTab(value)
  }

  return (
    <div className={classes.tabWrapper}>
      <ToggleButtonGroup
        className={classes.toggleGroup}
        value={tab}
        exclusive
        size="medium"
        color="primary"
        onChange={handleChange}
      >
        <ToggleButton value={EDashboardTab.Welcome}>
          <HelperWrapper t="welcome-header-title" />
        </ToggleButton>
        <ToggleButton value={EDashboardTab.Dashboard}>
          <HelperWrapper t="dashboard-header-title" ns={ETranslationNs.Navbar} />
        </ToggleButton>
      </ToggleButtonGroup>
      {tab === EDashboardTab.Welcome && !isSuccess && (
        <>
          <Button
            variant="outlined"
            size="small"
            disabled={isLoading}
            onClick={handleHide}
            className={classes.hideBtn}
          >
            <HelperWrapper t="welcome-hide-button" />
          </Button>
          <IconButton disabled={isLoading} onClick={handleHide} className={classes.hideIconBtn}>
            <CloseIcon />
          </IconButton>
        </>
      )}
    </div>
  )
}
